export const TRANSITION_DELAY = 60;
